import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { uuid } from 'src/app/services/helpers';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _loading$ = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading$.asObservable();
  
  public get loading() { return this._loading$.value; }

  requestList: RequestLoaderDto[] = [];

  requestStart(request: RequestLoaderDto) {
    this._loading$.next(true);
    this.requestList.push(request);
  }
  requestFinished(request: RequestLoaderDto) {
    const indexDeletedrequest = this.requestList.indexOf(request);
    if (indexDeletedrequest < 0) {
      return;
    }


    this.requestList.splice(indexDeletedrequest, 1);
    if (this.requestList.length == 0) {
      setTimeout(() => this._loading$.next(false), 0);
    }
  }
}
export class RequestLoaderDto {
  public id: string;
  constructor(public description?: string) {
    this.id = uuid();
  }
}